import { useController, useFormContext, useWatch } from 'react-hook-form';
import type { BadgeEditFormValues } from '@/components/Badge/BadgeEdit/BadgeEdit.types';
import Box from '@/components/UI/Box';
import Select from '@/components/UI/Select';
import Text from '@/components/UI/Text';

function BadgeEditAttributePreview() {
  const { control } = useFormContext<BadgeEditFormValues>();
  const { field } = useController({
    control,
    name: 'attribute_preview_id',
  });
  const badgeAttributes = useWatch({
    control,
    name: 'badge_attributes',
  });
  const initialBadgeAttribute = badgeAttributes?.find(
    (badgeAttribute) => badgeAttribute.id === field.value,
  );
  const badgeAttributesWithTitles = badgeAttributes?.filter(
    (badgeAttribute) => badgeAttribute.title.length > 0,
  );
  return (
    <Box direction="vertical" space="xs" mt="md">
      <Text px="xs" size="sm" variant="typographyMuted">
        Which attribute's entry should be shown as a preview throughout the app?
      </Text>
      <Select
        disabled={!badgeAttributesWithTitles?.length}
        onValueChange={field.onChange}
        value={initialBadgeAttribute ? field.value : ''}
        placeholder="Select Preview Attribute..."
        options={[
          {
            label: 'No Selection',
            value: '',
          },
          ...(badgeAttributesWithTitles?.map((badgeAttribute) => ({
            label: badgeAttribute.title,
            value: badgeAttribute.id,
          })) ?? []),
        ]}
      />
    </Box>
  );
}
export default BadgeEditAttributePreview;
